<div class="w-full h-full">
  <nav class="bg-white shadow border-b" aria-label="dispatch-routes-nav-bar">
    <div class="mx-auto px-4">
      <div class="flex justify-between h-16 my-auto">
        <div class="flex items-center gap-4 my-auto">
          <div class="space-x-4 ng-star-inserted">
            <div class="flex items-center justify-center bg-gray-100 rounded-md py-1 px-1 h-12"
              [hidden]="!moduleAccess.map">
              <button
                (click)="selectedRouteTab = 'TRACKING'; selectedDispatchTab = 'JOBS'; dispatchTabChange.emit('JOBS')"
                class="h-10 m-1 px-6 rounded-md py-1 font-medium transition flex items-center text-center justify-center border-ui-tertiary hover:bg-gray-200">
                <img class="w-6 h-7 mr-2" src="/assets/images/svgs/briefcase.svg" alt="">
                {{'text.jobs' | translate}}</button>
              <button (click)="selectedDispatchTab = 'ROUTES'"
                class="h-10 m-1 px-6 rounded-md py-1 transition flex items-center text-center justify-center bg-white shadow-sm font-semibold">
                <img class="w-6 h-7 mr-2" src="/assets/images/svgs/map-solid.svg" alt="">
                {{'text.routes'| translate}}</button>
            </div>
          </div>

          <!-- Tracking and Planning tab -->
          <ng-select class="text-base font-normal text-gray-700 w-44" [items]="routesTabViewOptions" bindValue="value"
            [(ngModel)]="routesTabView" (change)="onRoutesTabViewchange()" [searchable]="false" [clearable]="false"
            [appendTo]="'body'">
          
            <ng-template ng-label-tmp let-item="item">
              <div class="truncate font-medium" [title]="item.label | translate">
                {{ item.label | translate }}
              </div>
            </ng-template>
          
            <ng-template ng-option-tmp let-item="item">
              <div class="flex items-center primary-font font-medium text-gray-700 space-x-1.5" [title]="item.label | translate">
                {{ item.label | translate }}
              </div>
            </ng-template>
          </ng-select>

          <!-- Custom timezone -->
          <div class="flex items-center my-auto relative h-11 p-2 border border-gray-300 rounded-lg"
            *ngIf="_dispatchBoardService?.companyConfig?.multipleTimezone">
            <i class="ti ti-clock text-2xl mt-1 text-gray-700"
              title="{{'text.timezone' | translate}}"></i>
            <ng-select #dispatchCustomTimezone class="w-48 custom_timezone cursor-pointer static dispatchPicker"
              [(ngModel)]="_dispatchBoardService.customTimezone" [clearable]="false" [multiple]="false" [hideSelected]="true" [virtualScroll]="true"
              (change)="dispatchCustomTimezone.blur(); onCustomTimezoneChange();">
              <ng-option *ngFor="let timezone of _dispatchBoardService.timezones | async" [value]="timezone.key"><span
                  title="{{timezone.name}}">{{timezone.name}}</span></ng-option>
            </ng-select>
          </div>

          <!-- Service territory -->
          <div class="flex items-center my-auto relative h-11 p-2 border border-gray-300 rounded-lg" *ngIf="enableServiceTerritory">
            <i class="ti ti-compass text-2xl mt-1 text-gray-700"
                title="{{'text.service_territories' | translate}}"></i>
            <ng-select #serviceTerritoryPicker class="w-48 service-territory-picker cursor-pointer static dispatchPicker"
                [(ngModel)]="selectedServiceTerritory" [clearable]="false" [multiple]="false" [hideSelected]="false"
                placeholder="{{'text.choose_a_service_territory' | translate}}" [virtualScroll]="true"
                [items]="serviceTerritories | async" bindLabel="territory_name" bindValue="territory_uid" [searchable]="true" 
                [closeOnSelect]="true" (open)="onServiceTerritoryPickerOpen()"
                [notFoundText]="'dispatchBoard.navbar.service_territory.placeholder' | translate"
                [loading]="territorySearchPagination.isLoading" [typeahead]="serviceTerritoryValueSubject" (search)="onServiceTerritorySearch()"
                (scrollToEnd)="serviceTerritoryPickerScrollToEnd()" (change)="serviceTerritoryPicker.blur();onServiceTerritoryChange($event)">
            </ng-select>
        </div>

      </div>

        <div class="sm:ml-6 sm:flex sm:items-center my-auto gap-4">
          <div class="flex quickFilter">
            <ng-select #quickFilter id="dispatch_filter_select" name="filter"
              class="text-base min-w-50 max-w-64 quickFilterDropDown dispatchPicker" [(ngModel)]="selectedQuickFilter"
              [multiple]="false" [clearable]="false" [searchable]="false" [hideSelected]="false" [appendTo]="'body'"
              [closeOnSelect]="true" (change)="onQuickFilterChange($event, false, false)"
              [loading]="quickFilterLoading">
              <ng-option [value]="'ALL'">{{'dispatchBoard.navbar.default_filter' |
                translate}}</ng-option>
              <ng-option *ngFor="let filter of quickFilters"
                [value]="filter.filter_uid">{{filter.filter_name}}</ng-option>
              <ng-template ng-footer-tmp>
                <button (click)="quickFilter.close();addNewDispatchFilter()" [value]="'ADD'"
                  class="w-full sticky z-10 bottom-0 bg-card text-base px-1.5 py-2 hover:bg-gray-100">
                  <div class="flex justify-between">
                    <div><em class="ti ti-plus"></em> {{'dispatchBoard.navbar.filter.add_filter'
                      | translate}}</div>
                    <div class="mt-1"></div>
                  </div>
                </button>
                <button (click)="quickFilter.close();manageQuickFilters()" [value]="'MANAGE'"
                  class="w-full sticky z-10 bottom-0 bg-card text-base px-1.5 py-2 hover:bg-gray-100">
                  <div class="flex justify-between">
                    <div><em class="ti ti-settings"></em>
                      {{'manage_filter.text' | translate}}</div>
                    <div class="mt-1"></div>
                  </div>
                </button>
              </ng-template>
            </ng-select>
          </div>

          <!-- Create New Job/Route -->
          <div class="flex items-center">
            <button [matMenuTriggerFor]="createNew" *ngIf="permissions.newJob || permissions.createRoute"
                class="bg-primary text-base px-4 py-3 h-9 flex gap-2 items-center border-gray-300 shadow-sm text-white font-medium rounded-l-md text-white-600 focus:outline-none"
                type="button">
                {{'create' | translate}}
            </button>
            <div class="menu-button-divider"></div>
            <button [matMenuTriggerFor]="createNew" *ngIf="permissions.newJob || permissions.createRoute"
                class="bg-primary text-base px-2 py-2.5 h-9 flex gap-2 items-center border-gray-300 shadow-sm text-white font-medium rounded-r-md text-white-600 focus:outline-none">
                <i class="ti ti-chevron-down text-2xl text-white"></i>
            </button>
          </div>
          <mat-menu #createNew="matMenu" class="primary-font text-base text-gray-700 font-normal create-mat-menu context-menu-wrapper">
            <button class="text-gray-700 text-left w-full flex items-center text-base primary-font hover:bg-gray-100"
                *ngIf="permissions.newJob" 
                (click)="createNewJob(null)">
                <i class="ti ti-briefcase text-2xl"></i>
                <span>{{'job' | translate}}</span>
            </button>
            <button class="text-gray-700 text-left w-full flex items-center text-base primary-font hover:bg-gray-100"
                *ngIf="permissions.createRoute" 
                (click)="createNewRoute()">
                <i class="ti ti-route text-2xl"></i>
                <span>{{'text.route' | translate}}</span>
            </button>
          </mat-menu>
          <div class="divider"></div>
          <div class="flex items-center">
            <button (click)="openDispatchFilter('GRID')"
              class="icon-button"
              title="{{'text.filters' | translate}}">
              <i class="ti ti-filter text-2xl"></i>
            </button>
            <button class="icon-button"
              (click)="openSettingsDialog('GRID')" title="{{'text.settings' | translate}}">
              <i class="ti ti-settings text-2xl"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <!-- Content -->
  <div class="flex w-full h-full">
    <div class="flex w-full h-full board-with-nav">
      <as-split direction="horizontal" (dragEnd)='onMapViewDrag($event)'>
        <as-split-area [size]="dispatchRouteSplitSettings.size" [maxSize]="dispatchRouteSplitSettings?.maxSize"
          [minSize]="dispatchRouteSplitSettings?.minSize" class="overflow-hidden bg-gray-50" #gridSchedulerContainer>
          <as-split direction="{{dispatchRouteSplitSettings.orientation}}" class="bg-gray-100 default-drag-handler">
            <as-split-area [order]="dispatchRouteSplitSettings.grid.order"
              [size]="dispatchRouteSplitSettings.grid.size" [maxSize]="dispatchRouteSplitSettings.grid.maxSize"
              [minSize]="dispatchRouteSplitSettings.grid.minSize" class="overflow-hidden bg-gray-50">
              <div class="grid-wrapper" [ngClass]="{'h-full': 'selectedPlanningTab === `MAP`'}" [hidden]="recurringRouteDetails?.isOpened">
                <!-- Grid Tbar -->
                <header class="flex flex-col bg-white z-99 w-full border-b border-gray-200">
                  <!-- Jobs and Routes toggle  -->
                  <div
                    class="flex justify-between items-center my-auto bg-white overflow-x-auto overflow-y-hidden zuper-scrollbar">
                    <div class="w-full">
                      <div class="border-b border-gray-200">
                        <nav class="-mb-px flex space-x-8 justify-center h-16" aria-label="Tabs">
                          <button
                            [ngClass]="selectedGridTab === 'ROUTES' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
                            class="w-full flex space-x-2 items-center justify-center border-b-2 py-4 px-1 text-sm font-medium hover:bg-gray-200"
                            (click)="onToggleGridTab('ROUTES')">
                            <i class="ti ti-map text-2xl mt-1"></i>
                            <span class="text-lg font-semibold">{{'text.routes' | translate}}</span>
                          </button>
                          <button
                            [ngClass]="selectedGridTab === 'JOBS' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
                            class="w-full flex space-x-2 items-center justify-center border-b-2 py-4 px-1 text-sm font-medium hover:bg-gray-200"
                            (click)="onToggleGridTab('JOBS')">
                            <i class="ti ti-briefcase text-2xl mt-1"></i>
                            <span class="text-lg font-semibold">{{'text.jobs' | translate}}</span>
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                  <!-- Jobs Tbar -->
                  <div class="flex gap-4 justify-between bg-white overflow-y-auto h-18 my-0.5 w-full px-4 align-center items-center"
                    *ngIf="selectedGridTab === 'JOBS'">
                    <div class="w-48 h-full flex items-center jobType">
                      <ng-select
                        class="job-type-select w-inherit items-center text-base font-normal text-gray-700 dispatchPicker"
                        [items]="_dispatchBoardService.jobTypeOptions" bindValue="value" [(ngModel)]="gridTbarData[selectedGridTab].type"
                        (change)="changeGridJobType()" [searchable]="false" [clearable]="false" [appendTo]="'body'"
                        placeholder="{{ 'text.job_type' | translate }}">
                    
                        <ng-template ng-label-tmp let-item="item">
                          <div class="truncate font-medium" [title]="item?.label | translate">
                            {{ item?.label | translate }}
                          </div>
                        </ng-template>
                    
                        <ng-template ng-option-tmp let-item="item">
                          <div class="truncate" [title]="item.label | translate">
                            {{ item.label | translate }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>

                    <div class="flex items-center justify-between"
                      [ngClass]="{'w-auto': (gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM') || isDrawOnMapView}">
                      <div class="flex items-center justify-center gap-3 p-3 w-full"
                        *ngIf="(gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM') || isDrawOnMapView">
                        <mat-form-field appearance="fill" class="w-90">
                          <input matInput [(ngModel)]="gridTbarData[selectedGridTab].gridSearchKeyword"
                            placeholder="{{(selectedGridTab === 'JOBS'? 'dispatchBoard.grid.tbar.job_search_placeholder': 'placeholder.search_routes') | translate}}"
                            (keyup)="applyGridSearch($event)">
                          <button *ngIf="gridTbarData[selectedGridTab].gridSearchKeyword" matSuffix
                            mat-icon-button aria-label="Clear"
                            (click)="gridTbarData[selectedGridTab].gridSearchKeyword=''; applyGridSearch($event, 'clear')">
                            <mat-icon>close</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>
                      <button
                        *ngIf="!(gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM') && !isDrawOnMapView"
                        (click)="toggleGridSearch()" class="icon-button"
                        title="{{'text.search' | translate}}">
                        <i class="ti ti-search text-2xl"></i>
                      </button>
                      <button (click)="openDispatchFilter('GRID')"
                        class="icon-button relative items-center"
                        [ngClass]="{'py-2': filterCount.grid > 0}"
                        title="{{'text.filters' | translate}}">
                        <i class="ti ti-filter text-2xl"></i>
                        <div *ngIf="filterCount.grid > 0"
                          class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-2 dark:border-gray-900">
                          {{filterCount.grid}}</div>
                      </button>
                      <button [ngxTippy]="gridSortTemplate" [tippyName]="'routesGridSortTippy'"
                        [tippyProps]="gridSortTippyProps"
                        class="icon-button"
                        title="{{'text.sort' | translate}}">
                        <i class="ti ti-arrows-sort text-2xl"></i></button>
                    </div>
                  </div>

                  <!-- Routes tbar -->
                  <div class="flex gap-4 justify-between bg-white h-18 overflow-y-auto my-0.5 w-full px-4 align-center items-center"
                    *ngIf="selectedGridTab === 'ROUTES'">
                    <div class="w-56 h-full flex items-center">
                      <ng-select
                        class="job-type-select w-inherit text-base text-gray-700 dispatchPicker"
                        [items]="routeTypeOptions" bindValue="value" [(ngModel)]="gridTbarData.ROUTES.type"
                        (change)="changeGridRouteType()" [searchable]="false" [clearable]="false" [appendTo]="'body'">
                        <ng-template ng-label-tmp let-item="item">
                          <div class="truncate font-medium" [title]="item?.label | translate">
                            {{ item?.label | translate }}
                          </div>
                        </ng-template>
                      
                        <ng-template ng-option-tmp let-item="item">
                          <ng-container>
                            <div class="truncate" [title]="item.label | translate">
                              {{ item.label | translate }}
                            </div>
                          </ng-container>
                        </ng-template>
                      </ng-select>

                    </div>
                    <div class="flex items-center justify-between"
                      [ngClass]="{'w-auto': (gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM') || isDrawOnMapView}">
                      <div class="flex items-center justify-center gap-3 p-3 pr-0 w-full mr-2"
                        *ngIf="(gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM') || isDrawOnMapView">
                        <mat-form-field appearance="fill" class="w-90">
                          <input matInput [(ngModel)]="gridTbarData[selectedGridTab].gridSearchKeyword"
                            placeholder="{{(selectedGridTab === 'JOBS'? 'dispatchBoard.grid.tbar.job_search_placeholder': 'placeholder.search_routes') | translate}}"
                            (keyup)="applyGridSearch($event)">
                          <button *ngIf="gridTbarData[selectedGridTab].gridSearchKeyword" matSuffix
                            mat-icon-button aria-label="Clear"
                            (click)="gridTbarData[selectedGridTab].gridSearchKeyword=''; applyGridSearch($event, 'clear')">
                            <mat-icon>close</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>
                      <button
                        *ngIf="!(gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM') && !isDrawOnMapView"
                        (click)="toggleGridSearch()" class="icon-button"
                        title="{{'text.search' | translate}}">
                        <i class="ti ti-search text-2xl"></i>
                      </button>
                      <button (click)="openDispatchFilter('GRID')"
                        class="icon-button relative items-center"
                        [ngClass]="{'py-2': filterCount.grid_route > 0}"
                        title="{{'text.filters' | translate}}">
                        <i class="ti ti-filter text-2xl"></i>
                        <div *ngIf="filterCount.grid_route > 0"
                          class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-2 dark:border-gray-900">
                          {{filterCount.grid_route}}</div>
                      </button>
                      <button [ngxTippy]="routeSortTemplate" [tippyName]="'routesSortTippy'"
                        [tippyProps]="gridSortTippyProps"
                        class="icon-button"
                        title="{{'text.sort' | translate}}">
                        <i class="ti ti-arrows-sort text-2xl"></i></button>
                    </div>
                  </div>

                  <!-- Search -->
                  <div class="flex items-center justify-center gap-3 p-3 w-full"
                    *ngIf="(openGridSearch || gridTbarData[selectedGridTab].gridSearchKeyword.trim().length > 0) && !(gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM') && !isDrawOnMapView">
                    <mat-form-field appearance="fill" class="w-full">
                      <input matInput [(ngModel)]="gridTbarData[selectedGridTab].gridSearchKeyword" autoFocus
                        placeholder="{{(selectedGridTab === 'JOBS'? 'dispatchBoard.grid.tbar.job_search_placeholder': 'placeholder.search_routes') | translate}}"
                        (keyup)="applyGridSearch($event)">
                      <button *ngIf="gridTbarData[selectedGridTab].gridSearchKeyword" matSuffix
                        mat-icon-button aria-label="Clear"
                        (click)="gridTbarData[selectedGridTab].gridSearchKeyword=''; applyGridSearch($event, 'clear')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                </header>
                <!-- Grid View -->
                <main class="flex-1">
                  <div class="w-full h-full">
                    <div class="flex" id="route-card-view" class="w-full h-full py-1"
                      *ngIf="gridViewType === 'listView'">
                      <bryntum-grid #routeCardView id="routeCardView" [data]="routeCardData" [cls]="'min-h-0'"
                        [bodyCls]="'grid-body card-view'" [config]="cardConfig" [stripeFeature]="false">
                      </bryntum-grid>
                    </div>

                    <div class="flex" id="route-table-view" class="h-full w-inherit"
                      *ngIf="gridViewType === 'tableView'">
                      <bryntum-grid #routeTableView id="routeTableView" [columns]="tableConfig?.columns || []" [cls]="'min-h-0'"
                        [data]="tableData" [stripeFeature]="true" [cellEditFeature]="false" [headerMenuFeature]="false"
                        [cellMenuFeature]="false" [config]="tableConfig">
                      </bryntum-grid>
                    </div>
                  </div>
                </main>
                <!-- Grid Bbar -->
                <footer class="flex flex-col bg-white z-99 w-full border-t border-gray-200">
                  <div class="flex gap-4 justify-between bg-white p-1 h-18 w-full border-b px-4 align-center items-center overflow-x-auto zuper-scrollbar">
                    <div class="flex items-center space-x-1">
                        <button (click)="openSettingsDialog('GRID')"
                          class="icon-button"
                          title="{{'text.settings'| translate}}">
                          <i class="ti ti-settings text-2xl"></i></button>                    
                    </div>
                    <div class="flex gap-4 items-center">
                      <span>{{gridBbarData[selectedGridTab].totalGridRecords}} {{selectedGridTab === 'JOBS'?
                          ('text.jobs' |
                          translate) : ('text.routes' | translate)}}</span>
                      <div class="flex items-center pageNumber">
                        <mat-form-field appearance="fill" class="w-16">
                          <input inputmode="numeric"
                            oninput="this.value = this.value.replace(/^0+/,'').replace(/\D+/g, '')"
                            [(ngModel)]="gridBbarData[selectedGridTab].gridPageNumber"
                            (keyup)="updateGridPageNumber($event)"
                            (blur)="gridBbarData[selectedGridTab].gridPageNumber =selectedGridTab === 'JOBS' ?  gridParam['page']: routeParam['page']"
                            matInput>
                        </mat-form-field>
                      </div>
                      <span class="ml-3">{{'of' | translate}} {{gridBbarData[selectedGridTab].totalGridPage}}
                        {{'text.pages' | translate}}</span>
                    </div>
                    <div class="flex items-center justify-between mt-1.5">
                      <button [disabled]="loadingGridData" (click)="gridPageIncrement('prev')"
                        class="icon-button"
                        title="{{'dispatchBoard.icons.tooltip.prev_page' | translate}}">
                        <i class="ti ti-chevron-left text-2xl btnColor-black"></i></button>
                      <button [disabled]="loadingGridData" (click)="gridPageIncrement('next')"
                        class="icon-button"
                        title="{{'dispatchBoard.icons.tooltip.next_page' | translate}}">
                        <i class="ti ti-chevron-right text-2xl btnColor-black"></i></button>
                    </div>
                  </div>
                </footer>
              </div>
              <div class="grid-wrapper w-full" *ngIf="recurringRouteDetails?.isOpened">
                <recurring-route-details 
                  [recurringRouteUid]="recurringRouteDetails.routeUid"
                  [timezone]="selectedTimezone"
                  [performAction]="recurringRouteDetails?.performAction"
                  (actionEmitter)="recurringRouteDetailsEventEmitter($event)"></recurring-route-details>
              </div>
            </as-split-area>
            <!-- Recurring route details - Second panel expand/collpase floating button -->
            <div class="flex self-start relative" *ngIf="recurringRouteDetails?.isOpened">
              <button title="{{(_dispatchBoardService.recurringRouteDetails.routeSeriesSegment.isOpened ? 'collapse': 'expand') | translate}}"
                  class="flex justify-center items-center shadow-md rounded-full w-9 h-9 bg-white absolute -left-3 top-2 hover:bg-gray-50 active:bg-gray-100"
                  (click)="toggleRecurringRouteViewRouteSeries(!_dispatchBoardService.recurringRouteDetails.routeSeriesSegment.isOpened)">
                  <i *ngIf="!_dispatchBoardService.recurringRouteDetails.routeSeriesSegment.isOpened" class="ti ti-chevron-right text-2xl"></i>
                  <i *ngIf="_dispatchBoardService.recurringRouteDetails.routeSeriesSegment.isOpened" class="ti ti-chevron-left text-2xl"></i>
              </button>
            </div>
            <as-split-area
              [order]="dispatchRouteSplitSettings.scheduler?.order || 2" [visible]="this.dispatchRouteSplitSettings.visible.scheduler"
              [size]="dispatchRouteSplitSettings.scheduler.size" [maxSize]="dispatchRouteSplitSettings.scheduler.maxSize"
              [minSize]="dispatchRouteSplitSettings.scheduler.minSize" class="overflow-hidden bg-gray-50">
              <!-- Tabs -->
              <div class="w-full" *ngIf="showSchedulerPlanningNavTab">
                <Tabs [tabs]="schedulerPlanningNavTabs" [config]="schedulerPlanningNavTabConfig" [currentActiveTab]="selectedSchedulerPlanningNavTab" (selectedTab)="onSchedulerPlanningNavTabChange($event)"></Tabs>
              </div>

              <!-- Scheduler -->
              <div [ngClass]="showSchedulerPlanningNavTab? 'scheduler-with-tab-h': 'h-full'" [hidden]="(selectedRouteTab === 'PLANNING' && selectedPlanningTab === 'MAP') || (showSchedulerPlanningNavTab && selectedSchedulerPlanningNavTab !== 'DISPATCH_BOARD')">
                <div class="h-full flex flex-col bg-white z-99" id="scheduler">
                  <form
                    class="flex gap-4 justify-between overflow-x-auto overflow-y-hidden bg-white h-20 w-full border-b px-4 align-center items-center"
                    id="schedule-tbar" [formGroup]="schedulerTbarForm">
                    <div class="w-full flex items-center justify-between">
                      <div class="flex  gap-3 items-center justify-center">
                        <div class="flex">
                          <!-- TODO: If config has multiple team config true, we have to enable below-->
                          <ng-select *ngIf="false" class="w-48" [items]="teams | async" bindLabel="team_name"
                            bindValue="team_uid" formControlName="selectedTeam" [clearable]="false" [multiple]="true"
                            [searchable]="true" [hideSelected]="false" [closeOnSelect]="false"
                            (change)="onTeamChange()">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                              <input id="item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}"
                                [ngModel]="item$.selected" />
                              {{item.team_name}}
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              <div class="ng-value" *ngFor="let item of items | slice:0:2"
                                [ngClass]="{'hidden' : items.length>2}">
                                <span class="ng-value-label text-base">{{item.team_name}}</span>
                                <span class="ng-value-icon right text-base" (click)="clear(item)"
                                  aria-hidden="true">×</span>
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label text-base">{{items.length}} {{'text.teams_selected' | translate | lowercase}}</span>
                              </div>
                            </ng-template>
                          </ng-select>
                          <!-- TODO: If config has multiple team config false, we have to enable below-->
                          <ng-select class="w-48 teamSelector text-gray-700 dispatchPicker" #teamSelect [items]="teams | async" bindLabel="team_name"
                            bindValue="team_uid" formControlName="selectedTeam" [multiple]="false" [clearable]="false" placeholder="{{'text.choose_a_team' | translate}}"
                            [searchable]="true" [hideSelected]="false" [appendTo]="'body'" [closeOnSelect]="true"
                            (open)="onTeamPickerOpen()" [virtualScroll]="true"
                            [notFoundText]="'dispatchBoard.scheduler.team_select.empty' | translate"
                            [loading]="teamPickerLoading" [typeahead]="teamValueSubject" (search)="onTeamSearch()"
                            (scrollToEnd)="teamPickerScrollToEnd()" (change)="teamSelect.blur();onTeamChange()">
                          </ng-select>
                        </div>
                        <div
                          class="h-10 relative flex items-center rounded-md bg-white shadow-sm md:items-stretch schedulerDateField">
                          <div class="pointer-events-none absolute inset-0 rounded-md border border-gray-300"
                            aria-hidden="true"></div>
                          <button type="button" (click)="schedulerDateIncrement('prev')"
                            *ngIf="selectedRouteTab === 'TRACKING'" [disabled]="schedulerDatePrevBtn"
                            class="flex items-center justify-center border-r rounded-l-md py-2 pl-3 pr-4 text-gray-400 focus:relative md:w-9 md:px-2 hover:bg-gray-100 hover:text-gray-700 rounded-lg h-10 rounded-r-none">
                            <i class="ti ti-chevron-left text-2xl"></i>
                          </button>
                          <div *ngIf="selectedRouteTab === 'TRACKING'" class="flex items-center">
                            <input readonly [matDatepicker]="schedulerDatepicker"
                              [datePickerFormat]="_utilityService?.dateFormat" [max]="trackingMaxDate"
                              class="block w-24 pt-0.5 text-base px-0.5 text-center bg-white cursor-pointer font-medium"
                              placeholder="{{'text.choose_date.header' | translate}}" formControlName="schedulerDate"
                              (click)="schedulerDatepicker.open()" (dateChange)="onSchedulerDateChange()">
                            <mat-datepicker #schedulerDatepicker [dateClass]="routeDatePickerDateClass"></mat-datepicker>
                          </div>
                          <div *ngIf="selectedRouteTab === 'PLANNING'" class="flex items-center w-fit">
                            <div class="flex items-center cursor-pointer p-2 pl-1 mt-0.5">
                              <mat-date-range-input [rangePicker]="routeScheduleRangePicker"
                                (click)="routeScheduleRangePicker.open()" color="bg-indigo"
                                class="flex items-center justify-center px-2 w-full rounded-md bg-white shadow-xs cursor-pointer text-base font-medium"
                                [max]="_sharedService.routeSchedulerMaxEndDate">
                                <input matStartDate readonly [datePickerFormat]="_utilityService?.dateFormat"
                                  placeholder="{{'text.choose_date.header' | translate}}"
                                  formControlName="scheduleStartDate" class="cursor-pointer text-base text-center">
                                <input matEndDate readonly [datePickerFormat]="_utilityService?.dateFormat"
                                  placeholder="{{'text.choose_date.header' | translate}}"
                                  formControlName="scheduleEndDate" class="cursor-pointer text-base text-center">
                              </mat-date-range-input>
                              <mat-date-range-picker #routeScheduleRangePicker [dateClass]="routeDatePickerDateClass">
                                <mat-date-range-picker-actions>
                                  <div class="flex w-full justify-end border-t border-gray-300 px-3 pt-4 pb-2">
                                    <div class="flex justify-around space-x-4">
                                      <button type="button" matDateRangePickerCancel
                                        class="px-6 flex items-center py-2 border b-1 border-gray-300  text-black shadow-xs text-lg font-small rounded-md  bg-white focus:outline-none btn-small">
                                        {{'cancel.text' |
                                        translate}}</button>
                                      <button type="submit" matDateRangePickerApply
                                        (click)="onSchedulerDateRangeChange()"
                                        class="bg-primary px-6 flex items-center py-2 border b-1 shadow-xs text-white font-small rounded-md text-white-600 focus:outline-none btn-small">{{'text.apply'
                                        | translate}}</button>
                                    </div>
                                  </div>
                                </mat-date-range-picker-actions>
                              </mat-date-range-picker>
                            </div>
                          </div>
                          <span class="relative -mx-px h-5 w-px bg-gray-300 md:hidden"></span>
                          <button type="button" (click)="schedulerDateIncrement('next')"
                            *ngIf="selectedRouteTab === 'TRACKING'" [disabled]="schedulerDateNextBtn"
                            class="flex items-center justify-center rounded-r-md border-l py-2 pl-4 pr-3 text-gray-400 focus:relative md:w-9 md:px-2 hover:bg-gray-100 hover:text-gray-700 rounded-lg h-10 rounded-l-none">
                            <i class="ti ti-chevron-right text-2xl"></i>
                          </button>
                        </div>

                        <div class="flex items-center justify-center gap-1 cursor-pointer" *ngIf="selectedTeamTimezone && _dispatchBoardService.customTimezone === selectedTeamTimezone"
                          title="{{'text.timezone' | translate}}">
                          <i class="ti ti-clock-hour-2 text-2xl"></i>
                          <span class="text-lg font-medium">{{selectedTeamTimezone}}</span>
                        </div>
                      </div>
                      <div class="flex space-x-4 items-center">
                        <div class="flex items-center p-2 space-x-4">
                          <button
                            class="h-10 px-3 font-medium border border-gray-300 primary-font text-base text-gray-700 cursor-pointer hover:bg-gray-100 rounded"
                            (click)="scrollSchedulerToToady()" *ngIf="selectedRouteTab === 'TRACKING'">
                            {{'daterange.range.today.label' | translate}}
                          </button>
                          <div class="inline-flex h-10 rounded-md border border-gray-300 schedulerZoomActions" role="group">
                            <button type="button" [disabled]="schedulerZoomInBtnState"
                              title="{{'dispatchBoard.icons.tooltip.scheduler.zoomin' | translate}}" (click)="setSchedulerZoom('zoomIn')"
                              class="px-2 border-r border-gray-300 font-medium rounded-l-md flex items-center text-gray-700 hover:bg-gray-100 focus:z-10">
                              <i class="ti ti-zoom-in text-2xl text-gray-700"></i>
                            </button>
                            <button type="button" [disabled]="schedulerZoomOutBtnState"
                              title="{{'dispatchBoard.icons.tooltip.scheduler.zoomout' | translate}}" (click)="setSchedulerZoom('zoomOut')"
                              class="px-2 font-medium rounded-r-md flex items-center text-gray-700 hover:bg-gray-100 focus:z-10">
                              <i class="ti ti-zoom-out text-2xl text-gray-700"></i>
                            </button>
                          </div>
                        </div>
                        <div class="divider"></div>
                        <div class="flex items-center py-2">
                          <button [ngxTippy]="schedulerSearch" [tippyProps]="schedulerSearchTippyProps"
                            [tippyName]="'tippyRouteSchedulerSearch'"
                            class="icon-button relative"
                            title="{{'text.search' | translate}}">
                            <i class="ti ti-search text-2xl text-gray-700"></i>
                            <div class="w-2 h-2 bg-primary-600 rounded-full absolute top-1 right-1 z-10" *ngIf="appliedSchedulerSearchKeyword?.length && !schedulerSearchTippyInstance?.state?.isVisible"></div>
                          </button>
                          <button (click)="openDispatchFilter('SCHEDULER')"
                            class="icon-button relative items-center"
                            [ngClass]="{'py-2': filterCount.scheduler + filterCount.scheduler_route > 0}"
                            title="{{'text.filters' | translate}}">
                            <i class="ti ti-filter text-2xl text-gray-700"></i>
                            <div *ngIf="filterCount.scheduler + filterCount.scheduler_route > 0"
                              class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-2 dark:border-gray-900">
                              {{filterCount.scheduler + filterCount.scheduler_route}}</div>
                          </button>
                          <button (click)="openSettingsDialog('SCHEDULER')"
                            class="icon-button"
                            title="{{'text.settings' | translate}}">
                            <em class="ti ti-settings text-2xl text-gray-700"></em>
                          </button>
                        </div>
                      </div>
                    </div>

                  </form>
                  <div id="scheduler" class="flex flex-col w-full h-full"
                    [ngClass]="{'order-1' : this.metaData?.grid.table_grid_position === 'BOTTOM'}">
                    <bryntum-scheduler-pro #routeScheduler id="routeScheduler" [barMargin]="5" [autoAdjustTimeAxis]="false"
                      [columns]="schedulerProConfig?.columns || []" [eventRenderer]="schedulerProConfig.eventRenderer"
                      [timeZone]="selectedTimezone" [mode]="'horizontal'" [createEventOnDblClick]="false"
                      [project]="schedulerProConfig.project"
                      [config]="schedulerProConfig" ></bryntum-scheduler-pro>
                  </div>
                </div>
              </div>

              <!-- Map view -->
              <div [ngClass]="showSchedulerPlanningNavTab? 'scheduler-with-tab-h': 'h-full'" *ngIf="moduleAccess.map && _dispatchBoardService.activeDispatchTab === 'ROUTES' && showSchedulerPlanningNavTab && selectedSchedulerPlanningNavTab === 'MAP'">
                <div id="map-view" class="flex flex-col z-99 w-full" #mapContainer>
                  <div class="w-full h-full">
                    <app-map-main id="routes-map-bg" [isDispatch]="true" [mapView]="mapViewData" [timezone]="selectedTimezone"
                      [colorProfileOptions]="mapColorProfileOptions"
                      [enableDrawToCreateRoute]="true" (drawCompleted)="drawOnMapDrawCreatedEvent($event)"
                      (eventChange)="onMapEventChange($event)" (jobSelected)="onJobSelected($event)"></app-map-main>
                  </div>
                </div>
              </div>
            </as-split-area>
          </as-split>
        </as-split-area>
        <div *asSplitGutter class="h-full min-w-full relative gutter-wrapper" [hidden]="recurringRouteDetails.isOpened">
          <div class="w-12 h-12 flex items-center rounded-full z-99 absolute top-1/2 -left-4"
            [ngClass]="{'gutter-content': dispatchRouteSplitSettings.gutter.toggleState[1] === 'neutral' }">
            <button (click)="updateSplitVisibility(1, 'left')"
              [ngClass]="{'opacity-0 pointer-events-none': dispatchRouteSplitSettings.gutter.toggleState[1] === 'left' || (gridViewType === 'tableView' && metaData?.grid.table_grid_position === 'BOTTOM')}"
              class="h-full w-1/2 border-gray-200 bg-gray-100 hover:bg-gray-200 rounded-l-full flex items-center justify-center group">
              <i class="ti ti-chevron-left text-2xl group-hover:text-sky-600"></i>
            </button>
            <button (click)="updateSplitVisibility(1, 'right')"
              [ngClass]="{'opacity-0 pointer-events-none': dispatchRouteSplitSettings.gutter.toggleState[1] === 'right'}"
              class="h-full w-1/2 border-gray-200 bg-gray-100 hover:bg-gray-200 rounded-r-full flex items-center justify-center group">
              <i class="ti ti-chevron-right text-2xl group-hover:text-sky-600"></i>
            </button>
          </div>
        </div>
        <as-split-area [order]="dispatchRouteSplitSettings.map?.order || 3" [size]="dispatchRouteSplitSettings.map.size"
          [maxSize]="dispatchRouteSplitSettings.map.maxSize" [minSize]="dispatchRouteSplitSettings.map.minSize"
          class="overflow-hidden bg-gray-50 relative"
          *ngIf="isMapViewEnabled && moduleAccess.map && allowMapView && _dispatchBoardService.activeDispatchTab === 'ROUTES' && selectedRouteTab === 'TRACKING'">  
          <div id="map-view" class="flex flex-col z-99 w-full h-full" #mapContainer>
            <div class="w-full h-full">
              <app-map-main id="routes-map" [isDispatch]="true" [mapView]="mapViewData" [timezone]="selectedTimezone"
                [enableDrawToCreateRoute]="true" (drawCompleted)="drawOnMapDrawCreatedEvent($event)"
                (eventChange)="onMapEventChange($event)" [colorProfileOptions]="mapColorProfileOptions"
                (jobSelected)="onJobSelected($event)"></app-map-main>
            </div>
          </div>
        </as-split-area>
      </as-split>
    </div>
  </div>
</div>

<!-- Dispatch filter drawer -->
<app-dispatch-filter-drawer class="dispatch-board-filter" [isMapViewEnabled]="isMapViewEnabled"
  [openFilter]="dispatchFilterDrawerData.openFilter" [filterOptionalValues]="dispatchFilterDrawerData.filterOptionalValues"
  [ngClass]="{'-z-1': !dispatchFilterDrawerData.openFilter, 'z-auto': dispatchFilterDrawerData.openFilter }"
  [currentTab]="'ROUTES'" [dispatchFilterValues]="dispatchFilterDrawerData.dispatchFilterValues"
  [saveFilterByDefault]="dispatchFilterDrawerData.saveFilterByDefault"
  [hideSaveFilter]="dispatchFilterDrawerData.hideSaveFilter" [isNewFilter]="dispatchFilterDrawerData.addNewFilter"
  [selectedModule]="dispatchFilterDrawerData.selectedModule" [moduleAccess]="moduleAccess"
  (filterDrawerEmitter)="filterDrawerEmitter($event)" [additionalFilters]="dispatchFilterDrawerData?.additionalFilters"
  [filterTabs]="getDispatchFilterTabs()" [selectedTeamUid]="selectedTeam"></app-dispatch-filter-drawer>

<!-- Job sort template for tippy  -->
<ng-template #gridSortTemplate>
  <div class="text-base primary-font text-gray-700 font-normal">
    <div class="px-4 py-3 border-b border-gray-300">
      <span class="text-lg font-semibold">{{ 'text.sort' | translate }}</span>
    </div>
    <div class="w-48 flex flex-col">
      @if (gridParam?.['type'] !== 'UNSCHEDULED') {
        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'scheduled_start_time' }"
          (click)="setGridSort('sort_by', 'scheduled_start_time')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'scheduled_start_time',
            'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort_by !== 'scheduled_start_time'}">
            <span class="inline-block w-5 text-center">
              @if (gridTbarData[selectedGridTab].sortOptions?.sort_by === 'scheduled_start_time') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'text.scheduled_date' | translate }}</span>
          </div>
        </div>
      }

      <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
        [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'due_date' }"
        (click)="setGridSort('sort_by', 'due_date')">
        <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
          'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'due_date',
          'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort_by !== 'due_date'}">
          <span class="inline-block w-5 text-center">
            @if (gridTbarData[selectedGridTab].sortOptions?.sort_by === 'due_date') {
              <i class="ti ti-check text-xl"></i>
            }
          </span>
          <span>{{ 'due.date.text' | translate }}</span>
        </div>
      </div>

      <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
        [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'work_order_number' }"
        (click)="setGridSort('sort_by', 'work_order_number')">
        <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
          'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'work_order_number',
          'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort_by !== 'work_order_number'}">
          <span class="inline-block w-5 text-center">
            @if (gridTbarData[selectedGridTab].sortOptions?.sort_by === 'work_order_number') {
              <i class="ti ti-check text-xl"></i>
            }
          </span>
          <span>{{ 'dispatchBoard.grid.tbar.sort.job_id' | translate }}</span>
        </div>
      </div>

      <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
        [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'job_priority' }"
        (click)="setGridSort('sort_by', 'job_priority')">
        <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
          'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'job_priority',
          'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort_by !== 'job_priority'}">
          <span class="inline-block w-5 text-center">
            @if (gridTbarData[selectedGridTab].sortOptions?.sort_by === 'job_priority') {
              <i class="ti ti-check text-xl"></i>
            }
          </span>
          <span>{{ 'text.job_priority' | translate }}</span>
        </div>
      </div>

      <hr class="border-gray-200 my-1" />

      <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
        [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort === 'ASC' }"
        (click)="setGridSort('sort', 'ASC')">
        <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
          'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort === 'ASC',
          'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort !== 'ASC'}">
          <span class="inline-block w-5 text-center">
            @if (gridTbarData[selectedGridTab].sortOptions?.sort === 'ASC') {
              <i class="ti ti-check text-xl"></i>
            }
          </span>
          <span>{{ 'dispatchBoard.grid.tbar.sort.asc' | translate }}</span>
        </div>
      </div>

      <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
        [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort === 'DESC' }"
        (click)="setGridSort('sort', 'DESC')">
        <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
          'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort === 'DESC',
          'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort !== 'DESC'}">
          <span class="inline-block w-5 text-center">
            @if (gridTbarData[selectedGridTab].sortOptions?.sort === 'DESC') {
              <i class="ti ti-check text-xl"></i>
            }
          </span>
          <span>{{ 'dispatchBoard.grid.tbar.sort.desc' | translate }}</span>
        </div>
      </div>

      <div class="p-4">
        <button
          class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2 rounded-md transition-colors duration-200"
          type="button"
          (click)="applyGridSort('routesGridSortTippy')">
          {{ 'text.apply' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Grid-Routes sort template for tippy -->
<ng-template #routeSortTemplate>
  <div class="text-base primary-font text-gray-700 font-normal">
    <div class="px-4 py-3 border-b border-gray-300">
      <span class="text-lg font-semibold">{{ 'text.sort' | translate }}</span>
    </div>
    <div class="w-48 flex flex-col">
      @if (gridTbarData.ROUTES.type !== 'RECURRING_ROUTES') {
        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'departure' }"
          (click)="setGridSort('sort_by', 'departure')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'departure',
            'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort_by !== 'departure'}">
            <span class="inline-block w-5 text-center">
              @if (gridTbarData[selectedGridTab].sortOptions?.sort_by === 'departure') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'text.departure' | translate }}</span>
          </div>
        </div>

        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'route_name' }"
          (click)="setGridSort('sort_by', 'route_name')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort_by === 'route_name',
            'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort_by !== 'route_name'}">
            <span class="inline-block w-5 text-center">
              @if (gridTbarData[selectedGridTab].sortOptions?.sort_by === 'route_name') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'text.title' | translate }}</span>
          </div>
        </div>

        <hr class="border-gray-200 my-1" />

        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort === 'ASC' }"
          (click)="setGridSort('sort', 'ASC')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort === 'ASC',
            'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort !== 'ASC'}">
            <span class="inline-block w-5 text-center">
              @if (gridTbarData[selectedGridTab].sortOptions?.sort === 'ASC') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'dispatchBoard.grid.tbar.sort.asc' | translate }}</span>
          </div>
        </div>

        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': gridTbarData[selectedGridTab].sortOptions?.sort === 'DESC' }"
          (click)="setGridSort('sort', 'DESC')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': gridTbarData[selectedGridTab].sortOptions?.sort === 'DESC',
            'font-normal': gridTbarData[selectedGridTab].sortOptions?.sort !== 'DESC'}">
            <span class="inline-block w-5 text-center">
              @if (gridTbarData[selectedGridTab].sortOptions?.sort === 'DESC') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'dispatchBoard.grid.tbar.sort.desc' | translate }}</span>
          </div>
        </div>

        <div class="p-4">
          <button
            class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2 rounded-md transition-colors duration-200"
            type="button"
            (click)="applyGridSort('routesSortTippy')">
            {{ 'text.apply' | translate }}
          </button>
        </div>
      }

      @if (gridTbarData.ROUTES.type === 'RECURRING_ROUTES') {
        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': recurringRouteSortOptions?.sort_by === 'created_at' }"
          (click)="setRecurringRouteGridSort('sort_by', 'created_at')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': recurringRouteSortOptions?.sort_by === 'created_at',
            'font-normal': recurringRouteSortOptions?.sort_by !== 'created_at'}">
            <span class="inline-block w-5 text-center">
              @if (recurringRouteSortOptions?.sort_by === 'created_at') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'created.at.text' | translate }}</span>
          </div>
        </div>

        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': recurringRouteSortOptions?.sort_by === 'recurring_route_name' }"
          (click)="setRecurringRouteGridSort('sort_by', 'recurring_route_name')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': recurringRouteSortOptions?.sort_by === 'recurring_route_name',
            'font-normal': recurringRouteSortOptions?.sort_by !== 'recurring_route_name'}">
            <span class="inline-block w-5 text-center">
              @if (recurringRouteSortOptions?.sort_by === 'recurring_route_name') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'text.title' | translate }}</span>
          </div>
        </div>

        <hr class="border-gray-200 my-1" />

        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': recurringRouteSortOptions?.sort === 'ASC' }"
          (click)="setRecurringRouteGridSort('sort', 'ASC')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': recurringRouteSortOptions?.sort === 'ASC',
            'font-normal': recurringRouteSortOptions?.sort !== 'ASC'}">
            <span class="inline-block w-5 text-center">
              @if (recurringRouteSortOptions?.sort === 'ASC') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'dispatchBoard.grid.tbar.sort.asc' | translate }}</span>
          </div>
        </div>

        <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
          [ngClass]="{ 'bg-gray-100': recurringRouteSortOptions?.sort === 'DESC' }"
          (click)="setRecurringRouteGridSort('sort', 'DESC')">
          <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
            'font-semibold': recurringRouteSortOptions?.sort === 'DESC',
            'font-normal': recurringRouteSortOptions?.sort !== 'DESC'}">
            <span class="inline-block w-5 text-center">
              @if (recurringRouteSortOptions?.sort === 'DESC') {
                <i class="ti ti-check text-xl"></i>
              }
            </span>
            <span>{{ 'dispatchBoard.grid.tbar.sort.desc' | translate }}</span>
          </div>
        </div>

        <div class="p-4">
          <button
            class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2 rounded-md transition-colors duration-200"
            type="button"
            (click)="applyGridSort('routesSortTippy')">
            {{ 'text.apply' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- User sort template for tippy -->
<ng-template #userSortTemplate let-sortOptions="sortOptions" let-setUserSort="setUserSort"
    let-showSkillSubMenu="showSkillSubMenu" let-applyUserSort="applyUserSort"
    let-hideUserSkillSubMenu="hideUserSkillSubMenu" class="hidden">
    <div class="text-base primary-font text-gray-700 font-normal">
        <div class="px-4 py-3 border-b border-gray-300">
            <span class="text-lg font-semibold">{{ 'text.sort' | translate }}</span>
        </div>
        <div class="w-48 flex flex-col">
            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort_by === 'name' }"
                (click)="resetUserSortSkill();setUserSort('sort_by', 'name')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions?.user?.sort_by === 'name',
                 'font-normal': sortOptions?.user?.sort_by !== 'name' }">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions?.user?.sort_by === 'name') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'name.text' | translate }}</span>
                </div>
            </div>

            <div class="relative overflow-hidden" (mouseenter)="cancelUserSkillHideSubMenu()" (mouseleave)="onSkillParentLeave()">
                <div class="flex flex-col cursor-pointer hover:bg-gray-50 px-4 py-3"
                    [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort_by === 'skill', 'bg-white': userSortData.skillSubMenu?.isOpened && sortOptions?.user?.sort_by !== 'skill' }" #skillTriggerRef
                    (mouseenter)="showUserSkillSubMenu(skillTriggerRef)">
                    <div class="flex items-center justify-between w-full">
                        <div class="flex items-center gap-2 text-base text-gray-700" 
                            [ngClass]="{ 'font-semibold': sortOptions?.user?.sort_by === 'skill', 'font-normal': sortOptions?.user?.sort_by !== 'skill' }">
                            <span class="inline-block w-5 text-center">
                                @if (sortOptions?.user?.sort_by === 'skill') {
                                <i class="ti ti-check text-xl"></i>
                                }
                            </span>
                            <span>{{ 'text.skill' | translate }}</span>
                        </div>
                        <i class="ti ti-chevron-right text-xl text-gray-400 hover:text-gray-700"></i>
                    </div>
                    @if (sortOptions?.user?.sort_by === 'skill' && userSortData?.selectedSkillName) {
                        <span class="inline-block ml-[1.75rem] w-10/12 truncate text-gray-500 text-md" title="{{ userSortData.selectedSkillName }}">{{userSortData?.selectedSkillName}}</span>
                    }
                </div>
            </div>

            <hr class="border-gray-200 my-1" />

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort === 'ASC' }" (click)="setUserSort('sort', 'ASC')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions?.user?.sort === 'ASC',
                 'font-normal': sortOptions?.user?.sort !== 'ASC' }">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions?.user?.sort === 'ASC') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'dispatchBoard.grid.tbar.sort.asc' | translate }}</span>
                </div>
            </div>

            <div class="flex items-center cursor-pointer hover:bg-gray-50 px-4 py-3"
                [ngClass]="{ 'bg-gray-100': sortOptions?.user?.sort === 'DESC' }" (click)="setUserSort('sort', 'DESC')">
                <div class="flex items-center gap-2 text-base text-gray-700" [ngClass]="{
                 'font-semibold': sortOptions?.user?.sort === 'DESC',
                 'font-normal': sortOptions?.user?.sort !== 'DESC' }">
                    <span class="inline-block w-5 text-center">
                        @if (sortOptions?.user?.sort === 'DESC') {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span>{{ 'dispatchBoard.grid.tbar.sort.desc' | translate }}</span>
                </div>
            </div>

            <div class="p-4">
                <button
                    class="w-full bg-primary hover:bg-primary-dark text-white font-medium px-6 py-2 rounded-md transition-colors duration-200"
                    type="button" (click)="applyUserSort()">
                    {{ 'text.apply' | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!-- User sort skill submenu -->
<ng-template #skillSubMenuTemplate>
    <div class="relative w-64 z-10 primary-font" (mouseenter)="cancelUserSkillHideSubMenu()"
        (mouseleave)="hideUserSkillSubMenu()">
        <!-- Search in submenu -->
        <div class="p-3 border-b border-gray-100">
            <div class="relative flex items-center">
                <i class="ti ti-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-base"></i>
                <input type="text" placeholder="{{'text.search.skill' | translate}}"
                    [(ngModel)]="userSortData.skillSubMenu.searchKeyword" (ngModelChange)="onUserSortSkillSearch()"
                    class="w-full pl-8 pr-9 py-2.5 rounded-md border border-gray-200 focus:outline-none text-base primary-font text-gray-700" />
                @if (userSortData.skillSubMenu.searchKeyword) {
                <button
                    class="absolute right-2 w-6 h-6 pb-1 text-center rounded-full hover:bg-gray-100 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
                    (click)="userSortData.skillSubMenu.searchKeyword = ''; onUserSortSkillSearch()">
                    <i class="ti ti-x text-base"></i>
                </button>
                }
            </div>
        </div>

        <!-- Skills List - Scrollable -->
        <div class="max-h-64 overflow-y-auto py-1">
            @for (skill of userSortData.skillSubMenu.filteredSkillset; track skill?.skillset_uid) {
            <div class="px-3 py-3 hover:bg-gray-50 cursor-pointer flex items-center justify-between" (click)="selectUserSortSkill(skill)">
                <span class="text-gray-700 text-base primary-font font-normal flex items-center gap-2 overflow-hidden">
                    <span class="inline-block w-5 text-center">
                        @if (skill.selected) {
                        <i class="ti ti-check text-xl"></i>
                        }
                    </span>
                    <span class="block truncate" title="{{skill?.skillset_name}}">{{ skill?.skillset_name }}</span>
                </span>
            </div>
            } @empty {
            <div class="px-3 py-3 text-gray-700 text-center primary-font text-base font-normal">{{'text.skillsets.not.found' | translate}}</div>
            }
        </div>
    </div>
</ng-template>

@if (userSortData.isOpened) {
<div #userSortTippyWrapper class="hidden">
    <ng-container *ngTemplateOutlet="userSortTemplate; context: userSortTemplateContext"></ng-container>
</div>
}

@if (userSortData.skillSubMenu.isOpened) {
<div #userSkillSubMenuTippyWrapper>
    <ng-container *ngTemplateOutlet="skillSubMenuTemplate; context: userSortTemplateContext"></ng-container>
</div>
}
<!-- Employee search tippy -->
<div class="w-80 h-20 hidden" #employeeSearch>
  <div class="flex items-center justify-center gap-3 p-3 w-full">
    <mat-form-field appearance="fill" class="w-full">
      <input matInput [(ngModel)]="employeeSearchKeyword" id="schedulerEmpSearch_ROUTES" autocomplete="off"
        placeholder="{{'text.search_user' | translate}}"
        (keyup)="applyEmployeeSearch($event)">
      <button *ngIf="employeeSearchKeyword" matSuffix mat-icon-button aria-label="Clear"
        (click)="employeeSearchKeyword=''; applyEmployeeSearch($event, 'clear')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>

<!-- Assign Job to another Route -->
<div class="flex flex-auto w-full h-full routesPreviewWrapper">
  <zuper-drawer class="shadow-none routesPreview" [name]="routeAssignDrawerData.drawerName" [mode]="'over'"
    [fixed]="true" [position]="'right'" [transparentOverlay]="false"
    (openedChanged)="routeAssignDrawerCloseEvent($event)">
    <div class="h-full w-full">
      <div class="p-2 border-b border-gray-300 flex justify-between">
        <div class="primary-font font-bold text-lg text-gray-700 flex items-center pl-2">
          {{'team.delete.reassign.first.message' | translate}} - {{routeAssignDrawerData.jobTitle}}
        </div>
        <div>
          <button type="button" mat-icon-button (click)="routeAssignDrawerCloseEvent(false)">
            <em class="ti ti-x text-gray-700 text-xl"></em>
          </button>
        </div>
      </div>
      <div class="assign-route-drawer-component-height">
        <app-assign-route-component *ngIf="routeAssignDrawerData.show" [routeSelected]="routeAssignDrawerData.routeUid"
          [date]="routeAssignDrawerData.date" (routeUnlockEvent) = assignRouteDrawerRouteUnlockEvent($event)></app-assign-route-component>
      </div>
      <div class="absolute inset-x-0 bottom-0 border-t border-gray-200 px-4 py-5 sm:px-6">
        <div class="flex justify-end space-x-4 ml-auto">
          <button type="button" mat-stroked-button (click)="routeAssignDrawerCloseEvent(false)"
            class="px-6 items-center py-2 btn-small border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text'
            | translate}}</button>
          <button type="button" (click)="jobAssignToAnotherRoute()"
            class="bg-primary primary-font btn-small px-6 flex items-center py-2 border shadow-sm text-white text-base font-medium rounded-md focus:outline-none">
            {{'team.delete.reassign.first.message' | translate}}
          </button>
        </div>
      </div>
    </div>
  </zuper-drawer>
</div>

<!-- No Team Created Alert -->
<ng-template #noTeamAlertDialogContent let-hide>
  <div class="w-full h-full">
    <div class="w-full h-7/12">
      <img class="w-full h-7/12" src="assets/images/png/team_placeholder.png" alt="">
    </div>
    <div class="px-2 pb-6 flex flex-col justify-center items-center space-y-5">
      <div class="flex flex-col space-y-1 justify-center items-center">
        <span class="font-semibold text-xl">{{'dispatchBoard.scheduler.no_team.alert.title' | translate}}</span>
        <span class="text-gray-600 text-lg">{{'dispatchBoard.scheduler.no_team.alert.message' | translate}}</span>
      </div>
      <div class="flex items-center space-x-4">
        <button type="button"(click)=goBackFromCreateTeamAlert() class="px-6 py-2 border b-1 hover:bg-gray-100 border-gray-300 rounded-md cursor-pointer">{{'text.go_back'
          | translate}}</button>
        <button type="button" (click)="createNewTeam()"
          class="bg-primary px-6 flex items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-small rounded-md text-white-600 focus:outline-none btn-small">
          <i class="ti ti-plus text-2xl mr-2"></i> {{'create.team.text' |
          translate}}</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Route form -->
<app-create-route-form [options]="routeFormOption" [drawerName]="'detailsRouteForm'" [openPicker]="openRouteFormDrawer"
  [data]="routeFormCurrentRoute" [showRouteAlert]="true" [parentModule]="'dispatch'" [timezone]="selectedTimezone" (actionComplete)="onRouteFormDrawerClose($event)"></app-create-route-form>

<!-- Employee Details -->
<preview-data [drawerOpen]="previewDrawer.drawerOpen" [module]="previewDrawer.module"
  [previewDrawerName]="'dispatch_preview_drawer'" [moduleUID]="previewDrawer.moduleUID"
  [options]="previewDataOptions" (eventEmitter)="previewDrawerEventHandler($event)">
</preview-data>

<!-- Color Profiles -->
<create-color-profile [openDrawer]="colorProfiletCreateDrawerData?.openDrawer" [drawerName]="colorProfiletCreateDrawerData?.drawerName"  (actionEmitter)="colorProfileEventEmitter($event)"></create-color-profile>

<!-- New Job Form -->
<app-new-job [openDrawer]="newJobDrawerData.openNewJobDrawer" [timezone]="selectedTimezone"
  [jobObject]="newJobDrawerData.newJobPrefillData" [jobData]="newJobDrawerData.cloneJobData"
  (jobFormEmitter)="jobFormEmitHandler($event)"></app-new-job>

<!-- Scheduler search tippy -->
<ng-template #schedulerSearch let-hide>
  <div class="w-80 h-20 flex">
    <div class="flex items-center justify-center gap-3 p-3 w-full">
      <mat-form-field appearance="fill" class="w-full">
        <input matInput [(ngModel)]="schedulerSearchKeyword" id="schedulerJobSearch_ROUTES" autocomplete="off"
          placeholder="{{'placeholder.search_routes' | translate}}"
          (keyup)="applySchedulerSearch($event)">
        <button *ngIf="schedulerSearchKeyword" matSuffix mat-icon-button aria-label="Clear"
          (click)="schedulerSearchKeyword=''; applySchedulerSearch($event, 'clear')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<div class="max-h-72 hidden" #routeGridAssignedToContent>
  <quick-assign-employee [prefillUsers]="routeGridCardUserAssignTippyData.prefillUsers" [showUserTeamAndRole]="false" (selectedUsers)="routeGridCardUserAssignEmitter($event)"></quick-assign-employee>
</div>

<!-- Map Legend -->
<div class="legend-wrapper absolute bottom-3 right-14 text-base font-normal text-gray-700 primary-font max-w-3/4 overflow-hidden whitespace-nowrap" 
  #mapLegendContainer
  *ngIf="_dispatchBoardService.activeDispatchTab === 'ROUTES'">
  <div class="w-inherit bg-white shadow border expandable-panel py-2 px-4 flex items-center space-x-4 overflow-hidden justify-between rounded-l" id="map-legend-bar-route">
     <div class="flex-1 flex-shrink-0 flex items-center overflow-hidden whitespace-nowrap" #mapLegendWrapperRoute *ngIf="mapLegendData.legendDetails?.length">
         <div *ngFor="let legendDetail of mapLegendData.legendDetails; let i = index" class="flex-shrink-0 whitespace-nowrap"
             [ngClass]="{'ml-3.5': i !== 0}" #mapLegendItemsRoute>
             <div class="flex items-center space-x-2">
                 <div class="flex items-center space-x-2 w-8 h-8 justify-center rounded" [style.background]="legendDetail?.color">
                     <i class="ti text-2xl cursor-default" [style.color]="legendDetail?.textColor" [ngClass]="legendDetail?.icon"></i>
                 </div>
                 <span>{{legendDetail?.name}}</span>
             </div>
         </div>
     </div>
     <div class="flex-0 flex items-center space-x-2">
         <span class="font-medium" *ngIf="mapLegendData.extraCount">+ {{mapLegendData.extraCount}} {{'text.more' | translate}}</span>
         <div class="flex-shrink-0 flex-0 text-blue font-medium cursor-pointer" (click)="openColorProfileDrawer()">Open Color Profile</div>
     </div>
  </div>
</div>